<template>
  <sweet-modal
      :title="$t('engagement_dropdown_action_remove_BU_engagement')"
      blocking
      width="600px"
      ref="removeBUEngagement"
      class="modal"
      v-on:close="close">
    <el-form :model="form" status-icon :rules="rules" ref="form" class="demo-ruleForm">
      <el-form-item prop="businessUnitId" size="mini">
        <el-select v-model="form.businessUnitId" :placeholder="$t('modal_businessUnits')">
          <el-option
              v-for="bu in list"
              :key="bu.id"
              :label="bu.name"
              :value="bu.id"
              :disabled="bu.isLeader"
              @click.native="handleSelectBu(bu.id)"></el-option>
        </el-select>
      </el-form-item>
      <el-button size="medium" @click="remove('form')" type="primary">{{$t('general_remove')}}</el-button>
    </el-form>
  </sweet-modal>
</template>

<script>
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import axios from 'axios'
export default {
  name: "RemoveBUFromEngagementModal",
  components: {
    SweetModal
  },
  data(){
    return {
      list: [],
      form: {
        businessUnitId: null
      },
      rules: {
        businessUnitId: [
          { required: true, message: this.$t('modal_settings_fieldIsRequired'), trigger: 'change'}
        ]
      }
    }
  },
  methods:{
    async openModal(companyId, engagementId){
      try {
        // const buList = await this.directories(companyId)

        // const selectedBUs = await this.item(companyId, engagementId)

        // console.log('buList', buList, 'selectedBUs', selectedBUs)
        // if (buList.length && selectedBUs.length) {
        //   selectedBUs.map((val) => {
        //     this.list = this.list.concat(buList.filter(bal => bal.id === val))
        //   })
        // }

        this.list = await this.getBUList(companyId, engagementId)

        this.$refs.removeBUEngagement.open()

        console.log(this.list)
      } catch (err) {
        console.log(err)
      }
    },
    directories(companyId){
      return new Promise((resolve, reject) => {
        const loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/engagements/directories?companyId=${companyId}&operation=update`)
            .then(response => {
              console.log(response)
              loader.hide()
              resolve(response.data.businessUnitList)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
              reject(error)
            });
      })
    },
    item(companyId, engagementId) {
      return new Promise((resolve, reject) => {
        const loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .post(`/api/v1/engagements/item?companyId=${companyId}&engagementId=${engagementId}`)
            .then(response => {
              console.log(response)
              loader.hide()
              resolve(response.data.item.businessUnitManagerArr)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
              reject(error)
            });
      })
    },
    getBUList(companyId, engagementId) {
      return new Promise((resolve, reject) => {
        const loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
            .get(`/api/v1/engagements/managers?engagementId=${engagementId}`)
            .then(response => {
              console.log(response)
              loader.hide()
              resolve(response.data.list)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
              reject(error)
            });
      })
    },
    handleSelectBu(id){
      console.log(id)
    },
    remove(form){
      if (this.list.length < 2){
        return this.notification(this.$t('general_warning'), this.$t('notification_cantRemoveLastBu'), "info")
      }
      this.$refs[form].validate((valid) => {
        if (valid) {
          const loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .get(`/api/v1/engagements/deleteBuForEngagement?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&buId=${this.form.businessUnitId}`)
              .then(response => {
                console.log(response)
                loader.hide()
                this.$emit('loadList', {companyId: parseInt(this.$route.query.companyId), engagementId: parseInt(this.$route.query.engagementId)})
                this.$refs.removeBUEngagement.close()
                this.notification(this.$t('general_success'), this.$t('notification_engagementUpdated'), "success")
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
        }
      })
    },
    close(){
      this.$refs['form'].resetFields()
      this.list = []
      this.form.businessUnitId = null
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
  }
}
</script>

<style scoped>

</style>
